export default __webpack_public_path__ + "static/media/Chery-Genuine-Parts.cb41739f.webp";